module.exports = __webpack_public_path__ + "8ea0b61c9cced533d851df6fc6ad4fb7.svg";